import { z } from 'zod';
export const SavedViewSchema = z.object({
    id: z.string().min(1).max(64),
    name: z.string().trim().min(1).max(60),
    screen: z.enum(['contacts', 'companies', 'reviews', 'audit']),
    query: z.string().max(2000),
    createdAt: z.string(),
});
/**
 * Kept small on purpose. This is a shortcut list, not a filing system: past a
 * couple of dozen, finding the view costs more than rebuilding it.
 */
export const MAX_SAVED_VIEWS = 24;
export const SavedViewsSchema = z.object({ views: z.array(SavedViewSchema).max(MAX_SAVED_VIEWS) });
//# sourceMappingURL=savedViews.js.map